export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
}

export function trackBookingClick({ city, page_slug, destination_url }) {
  trackEvent('ghostie_booking_click', {
    city,
    page_slug,
    destination_url,
  });
}
